'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaOpenid = function FaOpenid(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.2 0v34.3l-6 2.8q-5.1-0.4-9.3-2.2t-6.5-4.7-2.4-6.1q0-3.1 2.2-5.9t6.2-4.5 8.7-2.4v3.8q-4.8 0.8-7.9 3.3t-3.2 5.7q0 3.4 3.5 6t8.7 3.2v-30.3z m15 13l0.8 8.7-11.7-2.6 3.3-1.8q-2.7-1.6-6.3-2.2v-3.9q6.2 0.8 10.7 3.6z' })
        )
    );
};

exports.default = FaOpenid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/openid.js
// module id = 975
// module chunks = 35783957827783